import _classCallCheck from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _defineProperty from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import classnames from 'classnames2';
import React from 'react';
import { matchDisplayName } from '../../utils';
import { Icon } from '../Icon';
import styles from './styles.scss';

var mapPropsToStyles = function mapPropsToStyles(props) {
  var _ref;

  return _ref = {}, _defineProperty(_ref, styles.disabled, props.disabled), _defineProperty(_ref, styles.sizeSmall, props.size === 'small'), _defineProperty(_ref, styles.wrapDisabled, props.disableWrap), _ref;
};

export var InputGroupText = function InputGroupText(props) {
  return React.createElement("div", {
    className: classnames(styles.inputGroupText, mapPropsToStyles(props))
  }, props.children);
};
export var InputGroupLabel = function InputGroupLabel(_ref2) {
  var id = _ref2.id,
      ariaLabel = _ref2.ariaLabel,
      children = _ref2.children,
      _ref2$htmlFor = _ref2.htmlFor,
      htmlFor = _ref2$htmlFor === void 0 ? '' : _ref2$htmlFor;
  return React.createElement("label", {
    id: id,
    "aria-label": ariaLabel,
    htmlFor: htmlFor,
    className: styles.inputGroupText
  }, children);
};
export var InputGroupPrefix = function InputGroupPrefix(props) {
  return React.createElement("div", {
    className: classnames(styles.inputGroupPrefix, mapPropsToStyles(props)),
    "data-test": props.dataTest
  }, React.Children.map(props.children, function (childRef) {
    if (matchDisplayName(childRef, 'Select')) {
      return React.cloneElement(childRef, {
        className: classnames(styles.inputGroupSelect, childRef.props.className)
      });
    } else {
      return childRef;
    }
  }));
};
export var InputGroupSuffix = function InputGroupSuffix(props) {
  return React.createElement("div", {
    className: classnames(styles.inputGroupSuffix, mapPropsToStyles(props)),
    "data-test": props.dataTest
  }, React.Children.map(props.children, function (childRef) {
    if (matchDisplayName(childRef, 'Select')) {
      return React.cloneElement(childRef, {
        className: classnames(styles.inputGroupSelect, childRef.props.className)
      });
    } else {
      return childRef;
    }
  }));
};
export var InputGroupIcon = function InputGroupIcon(props) {
  return React.createElement("div", {
    className: styles.inputGroupIcon
  }, React.createElement(Icon, Object.assign({}, props)));
};
export var InputGroup = /*#__PURE__*/function (_React$Component) {
  _inherits(InputGroup, _React$Component);

  var _super = _createSuper(InputGroup);

  function InputGroup() {
    _classCallCheck(this, InputGroup);

    return _super.apply(this, arguments);
  }

  _createClass(InputGroup, [{
    key: "render",
    value: function render() {
      var containerStyles = classnames(styles.inputGroup, this.props.className, _defineProperty({}, styles.widthFull, this.props.width === 'full'));
      return React.createElement("div", {
        className: containerStyles,
        "data-test": this.props.dataTest
      }, React.Children.map(this.props.children, function (childRef) {
        if (matchDisplayName(childRef, 'Input.')) {
          return React.cloneElement(childRef, {
            className: classnames(styles.inputGroupInput, childRef.props.className)
          });
        } else if (matchDisplayName(childRef, 'Select')) {
          return React.cloneElement(childRef, {
            className: classnames(styles.inputGroupSelect, childRef.props.className)
          });
        } else {
          return childRef;
        }
      }));
    }
  }]);

  return InputGroup;
}(React.Component);
InputGroup.Prefix = InputGroupPrefix;
InputGroup.Suffix = InputGroupSuffix;
InputGroup.Label = InputGroupLabel;
InputGroup.Text = InputGroupText;
InputGroup.Icon = InputGroupIcon;